import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { LocalStorageProvider } from './localstorageprovider';

/** Pass untouched request through to the next request handler. */
@Injectable()
export class RolesInterceptor implements HttpInterceptor {
  constructor(private localStorageService: LocalStorageProvider)
  {}
  intercept(req: HttpRequest<any>, next: HttpHandler):
    Observable<HttpEvent<any>> {

    let configUser = this.localStorageService.loggedUser.Config;

    if(configUser)
    {
      let idEmpresa = configUser.idEmpresa;
      let numContrato = configUser.numContrato;

      const withEmpresaContratoRequest = req.clone({
        headers: req.headers.set('cl_company', idEmpresa).set('cl_contract', numContrato)
      })

      return next.handle(withEmpresaContratoRequest);
    }


    return next.handle(req);
  }
}